/**
 * Admin Finance FX source controls (M1).
 */
import { requestJson } from "./apiClient";

export async function listFinanceFxAdminSources() {
  return requestJson("/api/admin/finance/fx/sources");
}

/**
 * @param {string} [sourceKey=platform_fx]
 */
export async function runFinanceFxSource(sourceKey = "platform_fx") {
  return requestJson(`/api/admin/finance/fx/sources/${encodeURIComponent(sourceKey)}/run`, {
    method: "POST",
  });
}
